import React from "react"
import { Modal } from "./Modal"
import { Text } from "./Text"

interface FilterModalProps {
  isVisible: boolean
  onClose: () => void
}

export const FilterModal: React.FC<FilterModalProps> = ({
  isVisible,
  onClose,
}) => {
  return (
    <Modal isVisible={isVisible} onClose={onClose} title="Filter Tasks">
      <Text className="text-center text-typography-500">
        Filter functionality will be implemented soon.
      </Text>
    </Modal>
  )
}
